export default {
    setSpidLevel(state,  spidLevel ) {
        state.spidLevel = spidLevel;
    },
    setSpName(state,  spName ) {
        state.spName = spName;
    },
    setProfile(state,  profile ) {
        state.profile = profile;
    },
};
